import { h } from 'preact';
import * as BaseComp from 'base/bolt/boltApp.js';
import Store from 'store/store';
// import s from 'base/bolt/boltApp.sss';

export default class BoltApp extends BaseComp.default {

	constructor(props) {
		super(props);
		this.simplePlayVideo = this.simplePlayVideo.bind(this);
		this.simplePauseVideo = this.simplePauseVideo.bind(this);
		Store.on('SIMPLE_PLAY_BACKGROUND_VIDEO', this.simplePlayVideo);
		Store.on('SIMPLE_PAUSE_BACKGROUND_VIDEO', this.simplePauseVideo);
	}


	simplePlayVideo() {
		const { headerBgVideoPaused } = this.state?.appState || {};
		if (headerBgVideoPaused) {
			return;
		}
		return super.simplePlayVideo();
	}

	simplePauseVideo() {
		this.$bgVideo?.pause();
	}

}
